<div
  class="fna-dropdown"
  [clickOutsideEnabled]="isShowingDropdown"
  (clickOutside)="onClickOutside($event)"
  [class.is-invalid]="hasError"
  [class.fna-dropdown--is-invalid]="hasError"
  [class.fna-dropdown--is-focused]="isShowingDropdown"
  [class.fna-dropdown--is-disabled]="disabled"
  [class.fna-dropdown--has-value]="hasValue"
  [style.maxWidth.px]="fullWidth ? null : 432"
>
  <div
    class="fna-dropdown__label form-control"
    [class.fna-dropdown__label--focused]="isShowingDropdown"
    (click)="toggleDropdown($event)"
  >
    {{ value }}

    <div class="fna-dropdown__icon"></div>
  </div>
  <div class="dropdown-menu alert-dropdown" *ngIf="isShowingDropdown">
    <ng-container *ngFor="let option of options; let i = index">
      <div
        class="dropdown-item"
        (click)="onOptionSelected(i)"
        [class.selected]="value === option"
      >
        {{ option }}
      </div>
    </ng-container>
  </div>
</div>
